import React from 'react'

export const Reminder = () =>
  <p className='napomena-slike'>
    <strong>NAPOMENA: </strong>
    Fotografije trebaju što bolje da predstave vašu firmu i djelatnost koju obavljate, kako bi posjetioci sajta izabrali
    da budu korisnici vaših usluga.
  </p>
